import { EnvironmentType } from '@/configs/environments/types'

export const config: EnvironmentType = {
  type: 'production',
  adisonOfwList: {
    baseUrl: 'https://api-ao-list.adison.co/api'
  },
  adisonOfw: {
    baseUrl: 'https://api-ao2.adison.co/api'
  },
  adisonOfwGlobal: {
    baseUrl: 'https://api-ao.g.adison.co/api'
  },
  firebase: {
    apiKey: 'AIzaSyCG3MTGNKwR8ptk70fdQGqEHkbdxsBbNns',
    authDomain: 'adison-offerwall-26c5e.firebaseapp.com', // 실환경은 추후에 Firebase 프로젝트 분리 고려도 해야합니다.
    databaseURL: 'https://adison-offerwall-26c5e.firebaseio.com',
    projectId: 'adison-offerwall-26c5e',
    storageBucket: 'adison-offerwall-26c5e.appspot.com',
    messagingSenderId: '921460748260',
    appId: '1:921460748260:web:85377de0f3a7ec3a0321f1',
    measurementId: 'G-X56CVLCGNK'
  }
}
